import React, { useState } from "react";
import { FaChevronDown, FaEye, FaEyeSlash } from "react-icons/fa";
import "./AddBranchModal.css";

const US_STATES = [
  { name: "Alabama", abbr: "Alabama" },
  { name: "Alaska", abbr: "Alaska" },
  { name: "Arizona", abbr: "Arizona" },
  { name: "Arkansas", abbr: "Arkansas" },
  { name: "California", abbr: "California" },
  { name: "Colorado", abbr: "Colorado" },
  { name: "Connecticut", abbr: "Connecticut" },
  { name: "Delaware", abbr: "Delaware" },
  { name: "Florida", abbr: "Florida" },
  { name: "Georgia", abbr: "Georgia" },
  { name: "Hawaii", abbr: "Hawaii" },
  { name: "Idaho", abbr: "Idaho" },
  { name: "Illinois", abbr: "Illinois" },
  { name: "Indiana", abbr: "Indiana" },
  { name: "Iowa", abbr: "Iowa" },
  { name: "Kansas", abbr: "Kansas" },
  { name: "Kentucky", abbr: "Kentucky" },
  { name: "Louisiana", abbr: "Louisiana" },
  { name: "Maine", abbr: "Maine" },
  { name: "Maryland", abbr: "Maryland" },
  { name: "Massachusetts", abbr: "Massachusetts" },
  { name: "Michigan", abbr: "Michigan" },
  { name: "Minnesota", abbr: "Minnesota" },
  { name: "Mississippi", abbr: "Mississippi" },
  { name: "Missouri", abbr: "Missouri" },
  { name: "Montana", abbr: "Montana" },
  { name: "Nebraska", abbr: "Nebraska" },
  { name: "Nevada", abbr: "Nevada" },
  { name: "New Hampshire", abbr: "New Hampshire" },
  { name: "New Jersey", abbr: "New Jersey" },
  { name: "New Mexico", abbr: "New Mexico" },
  { name: "New York", abbr: "New York" },
  { name: "North Carolina", abbr: "North Carolina" },
  { name: "North Dakota", abbr: "North Dakota" },
  { name: "Ohio", abbr: "Ohio" },
  { name: "Oklahoma", abbr: "Oklahoma" },
  { name: "Oregon", abbr: "Oregon" },
  { name: "Pennsylvania", abbr: "Pennsylvania" },
  { name: "Rhode Island", abbr: "Rhode Island" },
  { name: "South Carolina", abbr: "South Carolina" },
  { name: "South Dakota", abbr: "South Dakota" },
  { name: "Tennessee", abbr: "Tennessee" },
  { name: "Texas", abbr: "Texas" },
  { name: "Utah", abbr: "Utah" },
  { name: "Vermont", abbr: "Vermont" },
  { name: "Virginia", abbr: "Virginia" },
  { name: "Washington", abbr: "Washington" },
  { name: "West Virginia", abbr: "West Virginia" },
  { name: "Wisconsin", abbr: "Wisconsin" },
  { name: "Wyoming", abbr: "Wyoming" },
];

export default function AddBranchModal({
  open,
  onClose,
  formData,
  errors,
  submitError,
  isSubmitting,
  handleChange,
  handleSubmit,
  mode = "add",
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);

  if (!open) return null;

  const handleStateSelect = (abbr) => {
    handleChange({ target: { name: "state", value: abbr } });
    setIsStateDropdownOpen(false);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setIsStateDropdownOpen(false);
    onClose();
  };

  return (
    <div className="popup-overlay-branch">
      <div className="branch-register-form-container">
        <button className="popup-branch-close-button" onClick={handleClose}>
          ✕
        </button>
        <form className="branch-register-form" onSubmit={handleSubmit}>
          <h2>{mode === "edit" ? "Edit Branch" : "New Branch Registration"}</h2>
          <p style={{ color: "#4A5568" }}>
            {mode === "edit"
              ? "Update the branch information below"
              : "Please fill out the required information to register the branch"}
          </p>

          <h3>Branch Information</h3>

          <div className="form-group-branch">
            <label>
              Branch Name<span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              id="branchName"
              placeholder="Ex.WhyGrene"
              value={formData.branchName}
              onChange={handleChange}
            />
            {errors.branchName && (
              <span className="add-device-error-message">{errors.branchName}</span>
            )}
          </div>

          <div className="form-group-branch">
            <label>
              Address Line <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              id="addressLine"
              placeholder="Address Line 1"
              value={formData.addressLine}
              onChange={handleChange}
            />
            {errors.addressLine && (
              <span className="add-device-error-message">{errors.addressLine}</span>
            )}
          </div>

          <div className="form-row">
            <div className="form-group-branch">
              <label>
                City <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                name="city"
                className="wide-input"
                placeholder="Enter City"
                value={formData.city}
                onChange={handleChange}
              />
              {errors.city && (
                <span className="add-device-error-message">{errors.city}</span>
              )}
            </div>

            <div className="form-group-branch">
              <label>
                State <span className="required-asterisk">*</span>
              </label>
              <div className="custom-select-wrapper-state">
                <div
                  className="custom-select-display"
                  onClick={() => setIsStateDropdownOpen(!isStateDropdownOpen)}
                >
                  <span className="select-display-text">
                    {US_STATES.find((s) => s.abbr === formData.state)?.name ||
                      "--Select a State--"}
                  </span>
                  <FaChevronDown
                    className={`select-caret-icon ${isStateDropdownOpen ? "rotated" : ""}`}
                  />
                </div>
                {isStateDropdownOpen && (
                  <ul className="custom-options-list-state">
                    <li className="disabled-option">--Select a State--</li>
                    {US_STATES.map((state) => (
                      <li
                        key={state.abbr}
                        onClick={() => handleStateSelect(state.abbr)}
                        className={formData.state === state.abbr ? "selected" : ""}
                      >
                        {state.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {errors.state && (
                <span className="add-device-error-message">{errors.state}</span>
              )}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group-branch">
              <label>
                Country <span className="required-asterisk">*</span>
              </label>
              <select id="country" value={formData.country} onChange={handleChange}>
                <option value="US">United States</option>
              </select>
              {errors.country && (
                <span className="add-device-error-message">{errors.country}</span>
              )}
            </div>

            <div className="form-group-branch">
              <label>
                Zip Code <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                id="zipCode"
                placeholder="Zipcode"
                value={formData.zipCode}
                onChange={handleChange}
              />
              {errors.zipCode && (
                <span className="add-device-error-message">{errors.zipCode}</span>
              )}
            </div>
          </div>

          {mode !== "edit" && (
            <>
              <h3>Branch Admin Information</h3>

              <div className="form-row">
                <div className="form-group-branch">
                  <label>
                    First Name <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    placeholder="Ex. John"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                  {errors.firstName && (
                    <span className="add-device-error-message">{errors.firstName}</span>
                  )}
                </div>
                <div className="form-group-branch">
                  <label>
                    Last Name <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    placeholder="Ex. Doe"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                  {errors.lastName && (
                    <span className="add-device-error-message">{errors.lastName}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group-branch">
                  <label>
                    Email <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Ex. john@whygrene.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <span className="add-device-error-message">{errors.email}</span>
                  )}
                </div>

                <div className="form-group-branch">
                  <label>
                    Contact No.<span className="required-asterisk">*</span>
                  </label>
                  <div className="combined-phone-input-container">
                    <select
                      name="country"
                      id="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="phone-country-select"
                    >
                      <option value="US">US</option>
                    </select>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      className="phone-number-input"
                      placeholder="Ex.1234567891"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phone && (
                    <span className="add-device-error-message">{errors.phone}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group-branch">
                  <label>
                    Password <span className="required-asterisk">*</span>
                  </label>
                  <div className="input-with-icon">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <span className="icon" onClick={() => setShowPassword(!showPassword)}>
                      <FaEye className={showPassword ? "icon-visible" : "icon-hidden"} />
                      <FaEyeSlash className={showPassword ? "icon-hidden" : "icon-visible"} />
                    </span>
                  </div>
                  {errors.password && (
                    <span className="add-device-error-message">{errors.password}</span>
                  )}
                </div>

                <div className="form-group-branch">
                  <label>
                    Confirm Password <span className="required-asterisk">*</span>
                  </label>
                  <div className="input-with-icon">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                    />
                    <span
                      className="icon"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      <FaEye
                        className={showConfirmPassword ? "icon-visible" : "icon-hidden"}
                      />
                      <FaEyeSlash
                        className={showConfirmPassword ? "icon-hidden" : "icon-visible"}
                      />
                    </span>
                  </div>
                  {errors.confirmPassword && (
                    <span className="add-device-error-message">
                      {errors.confirmPassword}
                    </span>
                  )}
                </div>
              </div>
            </>
          )}

          {submitError && <div className="error-message-box">{submitError}</div>}

          <button type="submit" className="register-button" disabled={isSubmitting}>
            {isSubmitting
              ? (mode === "edit" ? "Saving..." : "Creating...")
              : (mode === "edit" ? "Save Changes" : "Register")}
            {isSubmitting && <span className="spinner" />}
          </button>
        </form>
      </div>
    </div>
  );
}
